import { action } from 'satcheljs';

/**
 * Action to update current service update status in the store.
 */
const setIsPerformingServiceUpdate = action(
    'SET_IS_PERFORMING_PBP_SERVICE_UPDATE',
    (isPerformingServiceUpdate: boolean) => ({
        isPerformingServiceUpdate,
    })
);

export default setIsPerformingServiceUpdate;
